module.exports = __webpack_public_path__ + "static/media/order_icon10.bb91f38e.png";